import Image from '@components/Image';
import ImageIndicator from '@components/ImageIndicator';
import Row from '@components/Row';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from '@router/Link';
import { useState } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';

import useNutritionExists from './hooks/useNutritionExists';
import ImageModal from './ImageModal';
import InfoIcon from './InfoIcon';
import SearchIcon from './SearchIcon';

interface Props {
    imageUrls?: string[];
    name: string;
    itemId: string;
}

function ItemImage({ imageUrls, name, itemId }:Props) {
    const [index, setIndex] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const nutritionExists = useNutritionExists(itemId);
    const isIndicatorVisible = (imageUrls?.length || 0) > 1;
    const [swiper, setSwiper] = useState<SwiperClass|undefined>(undefined);
    return (
        <ImageContainer >
            <Swiper slidesPerView={1}
                loop
                onSwiper={(s) => setSwiper(s)}
                onSlideChange={(s) => setIndex(s.realIndex)}
                css={css`width: 110px`} >
                {imageUrls?.map((imageUrl) => (
                    <SwiperSlide key={imageUrl}>
                        <SizedImage src={imageUrl}
                            key={imageUrl}
                            alt={name}
                            width={110}
                            height={110}/>
                    </SwiperSlide>
                ))}
            </Swiper>
            {isIndicatorVisible && (
                <ImageIndicator current={index}
                    size={imageUrls?.length || 0}
                    slickPrev={() => swiper?.slidePrev()}
                    slickNext={() => swiper?.slideNext()} />
            )}
            <InfoRow spacing={4}>
                {nutritionExists && (
                    <Link activityName='ItemNutritionModal'
                        activityParams={{ itemId }}>
                        <InfoIcon/>
                    </Link>
                )}
                {(imageUrls && imageUrls.length > 0) && (
                    <SearchIcon onClick={() => setIsOpen(true)}/>
                )}
            </InfoRow>
            {imageUrls && (
                <ImageModal images={imageUrls}
                    setIsOpen={setIsOpen}
                    isOpen={isOpen} />
            )}
        </ImageContainer>
    );
}

const ImageContainer = styled.div`
    margin-bottom: 10px;
    min-width: 244px;
    padding: 0 72px;
    position: relative;
    max-width: 100%;
`;

const InfoRow = styled(Row)`
    background-color: var(--color-gray2);
    border-radius: 12px;
    padding: 0 1px;
    position: absolute;
    right: 0;
    top: 0;  
`;

const SizedImage = styled(Image)`
    width: 110px;
    height: 110px;
    max-width: 110px;
    object-fit: cover;
`;

export default ItemImage;
